export default __webpack_public_path__ + "static/KIM_KETCH_WEB_BW-3a2b1c29c558f75bc2f4c39ccbe8dcb2.jpg";